import { useEffect, useState } from "react";
import { Search, Trash2, Image as ImageIcon, Link as LinkIcon } from "lucide-react";
import { api, uploadFile } from "../api.js";

export default function MaterialScreen() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [form, setForm] = useState({ name: "", source: "", link: "" });
  const [imageFile, setImageFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const load = () => api.list("materials").then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const filtered = items.filter((i) => i.name.toLowerCase().includes(q.toLowerCase()));

  const add = async (e) => {
    e.preventDefault();
    if (!form.name) return;
    setUploading(true);
    try {
      let imageUrl = null;
      if (imageFile) {
        const up = await uploadFile(imageFile);
        imageUrl = up.fileUrl;
      }
      await api.createItem("materials", { ...form, imageUrl });
      setForm({ name: "", source: "", link: "" });
      setImageFile(null);
      load();
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <div className="dx-search-box">
        <Search size={16} />
        <input className="dx-input" style={{ border: "none" }} placeholder="Material suchen…" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>

      <form className="dx-inline-form" onSubmit={add} style={{ marginTop: "16px", marginBottom: "20px" }}>
        <input className="dx-input" placeholder="Name" value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} />
        <input className="dx-input" placeholder="Bezugsquelle" value={form.source} onChange={(e) => setForm((f) => ({ ...f, source: e.target.value }))} />
        <input className="dx-input" placeholder="Link" value={form.link} onChange={(e) => setForm((f) => ({ ...f, link: e.target.value }))} />
        <label className="dx-file-picker">
          <ImageIcon size={16} /> {imageFile ? imageFile.name : "Foto wählen"}
          <input type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => setImageFile(e.target.files[0])} />
        </label>
        <button className="dx-btn dx-btn--primary" type="submit" disabled={uploading}>{uploading ? "Lädt…" : "Hinzufügen"}</button>
      </form>

      <div className="dx-material-grid">
        {filtered.map((m) => (
          <div key={m.id} className="dx-card dx-material-tile">
            <div className="dx-material-image">
              {m.image_url ? <img src={m.image_url} alt={m.name} /> : <ImageIcon size={28} className="dx-muted" />}
            </div>
            <strong>{m.name}</strong>
            {m.source ? <div className="dx-muted">{m.source}</div> : null}
            {m.link ? <a href={m.link} target="_blank" rel="noopener" className="dx-file-link"><LinkIcon size={13} /> Link öffnen</a> : null}
            <button className="dx-btn dx-btn--ghost" onClick={() => api.deleteItem("materials", m.id).then(load)}><Trash2 size={14} /> Löschen</button>
          </div>
        ))}
      </div>
    </div>
  );
}
